const state = {
  isDrag: false,
};

export default state;
